import styled from 'styled-components'
import CommonStyles from 'shared/style/commonPageStyles'

const Style = {
	Wrapper: CommonStyles.PageWrapper,

	PreviewImg: styled.img`
		width: 190px;
		height: 110px;
		object-fit: cover;
		object-position: center center;
		border-radius: 8px;
		margin: 8px 0;
	`,
}

export default Style
